import valuationTemplate1 from './singleAddRule.vue'
import valuationTemplate2 from './amountAddRule.vue'
import valuationTemplate3 from './packetAddRule.vue'
export default {
  name: 'customerProductModifyPrice',
  data () {
    return {
      modifyPrice: {
        custProductId: this.$route.query.custProductId,
        abilityId: this.$route.query.abilityId,
        custId: this.$route.query.custId,
        custName: this.$route.query.custName,
        abilityZhName: this.$route.query.abilityZhName,
        price: this.$route.query.price,
        accId: '',
        afterUnitPrice: '',
        remark: '',
        effectiveTime: '',
        certifications: [] // 调价凭证
      },
      strategyData: [],
      sysIds: [],
      strategyId: '',
      custProdAdjustPriceId: '',
      single: false,
      amountDosage: false,
      packetTime: false,
      singleData: {
        outputParamsPricings: [
          // { 模板数据
          //   outputParamsPricing: {
          //     pricing: [
          //       {
          //         type: '1', // 等于大于那列
          //         key: 'timeout',
          //         value: '3',
          //         timeout: '3' // 这个字段需拆分成上面的key value
          //       }
          //     ],
          //     price: '22'
          //   }
          // }
        ]
      }, // 规则数据 单次计价
      amountData: { // 调用 金额计价 规则
        outputParamsPricings: {
          section: [
            // {
            //   start: '1',
            //   end: '2',
            //   price: '10'
            // }
          ],
          outputParamsPricing: [
            // {
            //   pricing: [
            //     {
            //       type: '1',
            //       key: 'returnCode',
            //       value: '1',
            //       returnCode: '1' // 这个字段需拆分成上面的key value
            //     },
            //     {
            //       type: '5',
            //       key: 'serviceId',
            //       value: '4',
            //       serviceId: '4' // 这个字段需拆分成上面的key value
            //     }
            //   ]
            // }
          ]
        }
      },
      packetData: { // 包时段规则
        outputParamsPricings: {
          section: [
            // {
            //   start: '2019-01-22',
            //   end: '2019-01-25',
            //   time: ['2019-01-22', '2019-01-25'], // 需要把start和end合并到time数组
            //   price: '10',
            //   expectPrice: '100'
            // }
          ],
          outputParamsPricing: [
            // {
            //   pricing: [
            //     {
            //       type: '1',
            //       key: 'returnCode',
            //       value: '1',
            //       returnCode: '1' // 这个字段需拆分成上面的key value
            //     },
            //     {
            //       type: '5',
            //       key: 'serviceId',
            //       value: '4',
            //       serviceId: '4' // 这个字段需拆分成上面的key value
            //     }
            //   ]
            // }
          ]
        }
      },
      interfaceParams: [],
      accData: [],
      rules: {
        effectiveTime: [
          {
            required: true,
            message: '请选择调价生效时间',
            trigger: 'blur'
          }
        ]
      },
      saveParams: {
        remark: '',
        ruleNameCn: '',
        ruleNameEn: '',
        ruleState: '',
        templateId: '',
        userId: '',
        userName: '',
        strategyName: '',
        strategyId: '',
        ruleType: ''
      },
      num: '',
      size: '',
      strategyName: '',
      ruleType: '',
      uploadFile: this.$API.fileUpload,
      headers: {
        mtk: localStorage.getItem('usermtk')
      }
    }
  },
  components: {
    valuationTemplate1,
    valuationTemplate2,
    valuationTemplate3
  },
  created () {
    if (this.$route.query.num) {
      this.num = this.$route.query.num
      this.size = this.$route.query.size
    }
    this.querySearchSel()
  },
  methods: {
    querySearchSel () {
      /* 查询客户账户 */
      let _self = this
      let params = {
        custId: this.modifyPrice.custId
      }
      /* 请求计价策略 */
      this.$axios({
        method: 'post',
        url: _self.$API.product.queryStrategyList
      }).then((response) => {
        if (response.data.resData) {
          _self.strategyData = response.data.resData
        }
      }).catch((err) => {
        console.log(err)
      })
      this.$axios
        .get(this.$API.rechargeManagement.queryCustAccountsByCustId, {
          params: params
        })
        .then(function (r) {
          _self.accData = r.data.resData.custAccounts
          if (_self.accData) {
            _self.modifyPrice.accId = _self.accData[0].accId
          }
        })
        .catch(function (error) {})
      let params2 = {
        abilityId: this.modifyPrice.abilityId,
        custProdId: this.modifyPrice.custProductId
      }
      /* 查询计价字段列表 */
      let opPrd = {prodId: this.modifyPrice.abilityId}
      this.$axios
        .post(this.$API.product.queryChargeFieldsByProdId, opPrd)
        .then(function (r) {
          // let data = r.data.resData.paramNameList
          _self.interfaceParams = r.data.resData
          // if (data.length > 0) {
          //   for (let i = 0; i < data.length; i++) {
          //     if (data[i].paramType === '1') {
          //       _self.inputParams.push(data[i])
          //     }
          //   }
          // }
        })
        .catch(function (error) {
          console.log(error)
        })
      /* 查询其他相关 */
      this.$axios
        .post(
          this.$API.customerManagement.queryCustProdAdjustPriceInfoByCustProdId,
          params2
        )
        .then(function (r) {
          let data = r.data.resData
          _self.sysIds = data.rule.sysIds
          _self.modifyPrice.afterUnitPrice = data.afterUnitPrice
          _self.modifyPrice.remark = data.remark
          _self.modifyPrice.effectiveTime = data.effectiveTime
          _self.strategyId = data.rule.strategyId
          _self.custProdAdjustPriceId = data.custProdAdjustPriceId
          /* 调价凭证数组转换字段 */
          if (data.certifications) {
            let newArr = []
            for (let i = 0; i < data.certifications.length; i++) {
              let newObj = {}
              newObj.name = data.certifications[i].fileName
              newObj.url = data.certifications[i].fileUrl
              newArr.push(newObj)
            }
            _self.modifyPrice.certifications = _self.modifyPrice.certifications.concat(newArr)
          }
          _self.saveParams.remark = data.rule.remark
          _self.saveParams.ruleNameCn = data.rule.ruleNameCn
          _self.saveParams.ruleNameEn = data.rule.ruleNameEn
          _self.saveParams.ruleState = data.rule.ruleState
          _self.saveParams.templateId = data.rule.templateId
          _self.saveParams.userId = data.rule.userId
          _self.saveParams.userName = data.rule.userName
          _self.saveParams.ruleType = data.rule.ruleType
          _self.saveParams.strategyId = data.rule.strategyId
          _self.saveParams.strategyName = data.rule.strategyName
          _self.strategyName = data.rule.strategyName
          _self.ruleType = data.rule.ruleType
          let ruleData = JSON.parse(data.rule.ruleJson)
          if (data.rule.strategyId === '20171020110707_Yr2r1x61_1000003') { // 包时段
            _self.packetTime = true
            if (ruleData.outputParamsPricings) {
              _self.packetData.outputParamsPricings.section = [] // 每次重新请求清空数组
              _self.packetData.outputParamsPricings.outputParamsPricing = [] // 每次重新请求清空数组
              console.log(ruleData.outputParamsPricings)
              if (ruleData.outputParamsPricings.section) {
                // _this.packetData.outputParamsPricings.section = data.outputParamsPricings.section
                for (let t of ruleData.outputParamsPricings.section) {
                  let timeop = {}
                  timeop.price = t.price
                  timeop.expectPrice = t.expectPrice
                  timeop.time = []
                  timeop.time.push(t.start)
                  timeop.time.push(t.end)
                  _self.packetData.outputParamsPricings.section.push(timeop)
                }
              }
              for (let v of ruleData.outputParamsPricings.outputParamsPricing) {
                let packetOp = {}
                packetOp.pricing = []
                for (let i of v.pricing) {
                  let keyOP = {}
                  let key = Object.keys(i)[1]
                  if (key === 'type') {
                    key = Object.keys(i)[0]
                  }
                  keyOP.key = key
                  keyOP.value = i[key].replace(/"/g, '')
                  keyOP.type = i.type
                  packetOp.pricing.push(keyOP)
                }
                _self.packetData.outputParamsPricings.outputParamsPricing.push(packetOp)
                console.log(_self.packetData.outputParamsPricings)
              }
            }
          } else {
            _self.packetTime = false
          }
          if (data.rule.strategyId === '20171020110707_Yr2r1x61_1000002') { // 单次计价
            _self.single = true
            if (ruleData.outputParamsPricings.length) {
              _self.singleData.outputParamsPricings = [] // 每次重新请求清空数组
              for (let v of ruleData.outputParamsPricings) {
                let op = {}
                op.outputParamsPricing = {}
                op.outputParamsPricing.price = v.outputParamsPricing.price
                op.outputParamsPricing.pricing = []
                for (let i of v.outputParamsPricing.pricing) {
                  let ruleOp = {}
                  let key = Object.keys(i)[1]
                  if (key === 'type') {
                    key = Object.keys(i)[0]
                  }
                  ruleOp.type = i.type
                  ruleOp.value = i[key].replace(/"/g, '')
                  ruleOp.key = key
                  op.outputParamsPricing.pricing.push(ruleOp)
                }
                _self.singleData.outputParamsPricings.push(op)
              }
            }
          } else {
            _self.single = false
          }
          if (data.rule.strategyId === '20171020110707_Yr2r1x61_1000001' || data.rule.strategyId === '20171020110707_Yr2r1x61_1000000') { // 调用量阶梯收费/金额阶梯收费
            _self.amountDosage = true
            if (ruleData.outputParamsPricings) {
              _self.amountData.outputParamsPricings.section = [] // 每次重新请求清空数组
              _self.amountData.outputParamsPricings.outputParamsPricing = [] // 每次重新请求清空数组
              if (ruleData.outputParamsPricings.section) {
                _self.amountData.outputParamsPricings.section = ruleData.outputParamsPricings.section
              }
              for (let v of ruleData.outputParamsPricings.outputParamsPricing) {
                let ruleAmountOp = {}
                ruleAmountOp.pricing = []
                for (let i of v.pricing) {
                  let keyOP = {}
                  let key = Object.keys(i)[1]
                  if (key === 'type') {
                    key = Object.keys(i)[0]
                  }
                  keyOP.key = key
                  keyOP.value = i[key].replace(/"/g, '')
                  keyOP.type = i.type
                  ruleAmountOp.pricing.push(keyOP)
                }
                _self.amountData.outputParamsPricings.outputParamsPricing.push(ruleAmountOp)
              }
            }
          } else {
            _self.amountDosage = false
          }
        })
        .catch(function (error) {})
    },
    addGroup (op) { // 单次计价 新增计价表
      this.singleData.outputParamsPricings.push(op)
    },
    removeGroup (index) { // 单次计价 删除计价表
      if (this.singleData.outputParamsPricings.length !== 1 && this.singleData.outputParamsPricings.length !== 0) {
        this.singleData.outputParamsPricings.splice(index, 1)
      }
    },
    addSection (op) { // 金额 调用计费 添加区间
      this.amountData.outputParamsPricings.section.push(op)
    },
    removeSection (index) { // 金额 调用计费 删除区间
      if (this.amountData.outputParamsPricings.section.length !== 1 && this.amountData.outputParamsPricings.section.length !== 0) {
        this.amountData.outputParamsPricings.section.splice(index, 1)
      }
    },
    addConfigure (op) { // 金额 调用计费 新增计费配置
      this.amountData.outputParamsPricings.outputParamsPricing.push(op)
    },
    removeConfigure (index) { // 金额 调用计费 删除计费配置
      if (this.amountData.outputParamsPricings.outputParamsPricing.length !== 1 && this.amountData.outputParamsPricings.outputParamsPricing.length !== 0) {
        this.amountData.outputParamsPricings.outputParamsPricing.splice(index, 1)
      }
    },
    addpacketSection (op) { // 包时段
      this.packetData.outputParamsPricings.section.push(op)
    },
    removepacketSection (index) { // 包时段
      if (this.packetData.outputParamsPricings.section.length !== 1 && this.packetData.outputParamsPricings.section.length !== 0) {
        this.packetData.outputParamsPricings.section.splice(index, 1)
      }
    },
    addpacketConfigure (op) {
      this.packetData.outputParamsPricings.outputParamsPricing.push(op)
    },
    removepacketConfigure (index) {
      if (this.packetData.outputParamsPricings.outputParamsPricing.length !== 1 && this.packetData.outputParamsPricings.outputParamsPricing.length !== 0) {
        this.packetData.outputParamsPricings.outputParamsPricing.splice(index, 1)
      }
    },
    /* 点击上传文件钩子 */
    handlePreview (file) {},
    /* 上传前校验大小限制 */
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        })
      }
      return isLt2M
    },
    changeRule (val) { // 计价模板的更换
      if (val === '20171020110707_Yr2r1x61_1000001' || val === '20171020110707_Yr2r1x61_1000000') { // 金额 调用量
        this.amountDosage = true
        this.single = false
        this.packetTime = false
        if (val === '20171020110707_Yr2r1x61_1000001') {
          this.strategyName = '调用量阶梯收费'
          this.ruleType = 3
        }
        if (val === '20171020110707_Yr2r1x61_1000000') {
          this.strategyName = '金额阶梯收费'
          this.ruleType = 2
        }
        this.amountData.outputParamsPricings.section = [
          {
            time: '',
            price: '',
            expectPrice: ''
          }
        ]
        this.amountData.outputParamsPricings.outputParamsPricing = [
          {
            pricing: [
              {
                type: '',
                key: '',
                value: ''
              }
            ]
          }
        ]
      } else if (val === '20171020110707_Yr2r1x61_1000002') { // 单次计价
        this.single = true
        this.amountDosage = false
        this.packetTime = false
        this.strategyName = '单次计价收费'
        this.ruleType = 1
        this.singleData.outputParamsPricings = [
          {
            outputParamsPricing: {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ],
              price: ''
            }
          }
        ]
      } else if (val === '20171020110707_Yr2r1x61_1000003'){ // 包时段
        this.packetTime = true
        this.amountDosage = false
        this.single = false
        this.strategyName = '包时段收费'
        this.ruleType = 4
        this.packetData.outputParamsPricings.section = [
          {
            time: '',
            price: '',
            expectPrice: ''
          }
        ]
        this.packetData.outputParamsPricings.outputParamsPricing = [
          {
            pricing: [
              {
                type: '',
                key: '',
                value: ''
              }
            ]
          }
        ]
      } else {
        this.single = false
        this.amountDosage = false
        this.packetTime = false
      }
    },
    /* 返回列表 */
    returnList () {
      this.$store.commit('closeTab', this.$route) // 关闭当前路由
      this.$router.push({
        path: '/customerProductManage',
        query: {
          num: this.num,
          size: this.size
        }
      })
    },
    /* 保存客户信息 */
    saveModifyPrice (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let _self = this
          let files = this.modifyPrice.certifications
          let _certifications = []
          if (files) {
            let newArr = []
            for (let i = 0; i < files.length; i++) {
              let newObj = {}
              newObj.fileName = files[i].name
              newObj.fileUrl = files[i].url
              newArr.push(newObj)
            }
            _certifications = _certifications.concat(newArr)
          }
          let params = {
            afterUnitPrice: this.modifyPrice.afterUnitPrice,
            beforeUnitPrice: this.modifyPrice.price,
            certifications: files ? _certifications : [],
            custAccountId: this.modifyPrice.accId,
            custId: this.modifyPrice.custId,
            custProdAdjustPriceId: this.custProdAdjustPriceId,
            custProdId: this.modifyPrice.custProductId,
            custProdName: this.modifyPrice.abilityZhName,
            effectiveTime: this.modifyPrice.effectiveTime,
            remark: this.modifyPrice.remark,
            rule: {} // TODO 规则待补充
          }
          params.fieldIds = []
          params.prodId = this.modifyPrice.abilityId
          let ruleJson = {}
          ruleJson.inputParamsPricing = {}
          if (this.strategyId === '20171020110707_Yr2r1x61_1000002') { // 单次计价
            ruleJson.inputParamsPricing.pricingunit = []
            ruleJson.inputParamsPricing.inputParamsPricingFlag = true
            ruleJson.outputParamsPricings = []
            console.log(this.singleData.outputParamsPricings)
            for (let v of this.singleData.outputParamsPricings) {
              let obj = {}
              obj.outputParamsPricing = {}
              if (v.outputParamsPricing.price === '') {
                this.$message({
                  message: '价格不能为空!',
                  type: 'warning'
                })
                return
              }
              params.afterUnitPrice = v.outputParamsPricing.price
              obj.outputParamsPricing.pricing = []
              for (let i of v.outputParamsPricing.pricing) {
                let opSingle = {}
                opSingle.type = i.type
                let key = i.key
                opSingle[key] = '\"' + i.value + '\"'
                if (i.value === '') {
                  this.$message({
                    message: '计价值不能为空!',
                    type: 'warning'
                  })
                  return
                }
                if (i.type === '') {
                  this.$message({
                    message: '输入不能为空!',
                    type: 'warning'
                  })
                  return
                }
                for (let p of this.interfaceParams) {
                  if (i.key === p.fieldName) {
                    params.fieldIds.push(p.fieldId)
                  }
                }
                obj.outputParamsPricing.pricing.push(opSingle)
              }
              obj.outputParamsPricing.price = v.outputParamsPricing.price
              ruleJson.outputParamsPricings.push(obj)
            }
          } else if (this.strategyId === '20171020110707_Yr2r1x61_1000001' || this.strategyId === '20171020110707_Yr2r1x61_1000000') { // 金额 调用量
            ruleJson.outputParamsPricings = {}
            ruleJson.outputParamsPricings.section = this.amountData.outputParamsPricings.section
            let verification = true
            this.amountData.outputParamsPricings.section.forEach((item, index) => {
              if (parseInt(item.end.replace(/-/g, "")) > parseInt(item.start.replace(/-/g, ""))) {
                if (index > 0) {
                  if (parseInt(item.start.replace(/-/g, "")) >= parseInt(this.amountData.outputParamsPricings.section[index - 1].end.replace(/-/g, ""))) {
                  } else {
                    verification = false
                  }
                }
              } else {
                verification = false
              }
              params.afterUnitPrice = item.price
            })
            if (!verification) {
              this.$message({
                message: '区间不能有交集!',
                type: 'warning'
              })
              return
            }
            ruleJson.outputParamsPricings.outputParamsPricing = []
            for (let v of this.amountData.outputParamsPricings.outputParamsPricing) {
              let opAmount = {}
              opAmount.pricing = []
              for (let o of v.pricing) {
                let op = {}
                op.type = o.type
                let key = o.key
                op[key] = '\"' + o.value + '\"'
                if (o.value === '') {
                  this.$message({
                    message: '计价值不能为空!',
                    type: 'warning'
                  })
                  return
                }
                if (o.type === '') {
                  this.$message({
                    message: '输入不能为空!',
                    type: 'warning'
                  })
                  return
                }
                for (let p of this.interfaceParams) {
                  if (key === p.fieldName) {
                    params.fieldIds.push(p.fieldId)
                  }
                }
                opAmount.pricing.push(op)
              }
              ruleJson.outputParamsPricings.outputParamsPricing.push(opAmount)
            }
          } else if (this.strategyId === '20171020110707_Yr2r1x61_1000003'){ // 包时段
            ruleJson.outputParamsPricings = {}
            ruleJson.outputParamsPricings.section = []
            for (let k of this.packetData.outputParamsPricings.section) {
              let secOP = {}
              if ((k.time && !k.time.length) || !k.time) {
                this.$message({
                  message: '区间不能为空!',
                  type: 'warning'
                })
                return
              }
              secOP.start = k.time[0]
              secOP.end = k.time[1]
              secOP.price = k.price
              secOP.expectPrice = k.expectPrice
              if (k.price === '') {
                this.$message({
                  message: '价格不能为空!',
                  type: 'warning'
                })
                return
              }
              params.afterUnitPrice = k.price
              if (k.expectPrice === '') {
                this.$message({
                  message: '预付成本不能为空!',
                  type: 'warning'
                })
                return
              }
              ruleJson.outputParamsPricings.section.push(secOP)
            }
            let verification = true
            ruleJson.outputParamsPricings.section.forEach((item, index) => {
              if (parseInt(item.end.replace(/-/g, "")) > parseInt(item.start.replace(/-/g, ""))) {
                if (index > 0) {
                  if (parseInt(item.start.replace(/-/g, "")) >= parseInt(ruleJson.outputParamsPricings.section[index - 1].end.replace(/-/g, ""))) {
                  } else {
                    verification = false
                  }
                }
              } else {
                verification = false
              }
            })
            if (!verification) {
              this.$message({
                message: '区间不能有交集!',
                type: 'warning'
              })
              return
            }
            ruleJson.outputParamsPricings.outputParamsPricing = []
            for (let v of this.packetData.outputParamsPricings.outputParamsPricing) {
              let opAmount = {}
              opAmount.pricing = []
              for (let o of v.pricing) {
                let op = {}
                op.type = o.type
                let key = o.key
                op[key] = '\"' + o.value + '\"'
                if (o.value === '') {
                  this.$message({
                    message: '计价值不能为空!',
                    type: 'warning'
                  })
                  return
                }
                if (o.type === '') {
                  this.$message({
                    message: '输入不能为空!',
                    type: 'warning'
                  })
                  return
                }
                for (let p of this.interfaceParams) {
                  if (key === p.fieldName) {
                    params.fieldIds.push(p.fieldId)
                  }
                }
                opAmount.pricing.push(op)
              }
              ruleJson.outputParamsPricings.outputParamsPricing.push(opAmount)
            }
          }
          ruleJson = JSON.stringify(ruleJson)
          params.rule.ruleJson = ruleJson
          params.rule.sysIds = this.sysIds
          if (!this.sysIds.length) {
            this.$message({
              message: '产品未绑定默认计价规则，请在云端产品管理中绑定计价规则，然后重新调价!',
              type: 'error'
            })
            return
          }
          params.rule.remark = this.saveParams.remark
          params.rule.ruleNameCn = this.saveParams.ruleNameCn
          params.rule.ruleNameEn = this.saveParams.ruleNameEn
          params.rule.ruleState = this.saveParams.ruleState
          params.rule.templateId = this.saveParams.templateId
          params.rule.userId = this.saveParams.userId
          params.rule.userName = this.saveParams.userName
          params.rule.strategyName = this.strategyName
          params.rule.strategyId = this.strategyId
          params.rule.ruleType = this.ruleType
          this.$axios({
            url: this.$API.customerManagement.adjustCustProdPrice,
            method: 'post',
            data: params
          }).then((response) => {
            this.$message({
              message: '调价保存成功!',
              type: 'success'
            })
            this.$store.commit('closeTab', this.$route) // 关闭当前路由
            this.$router.push({
              path: '/customerProductManage'
            })
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/customerManagement/customerProductModifyPrice.js